import React from 'react';
import { Badge, Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { SideBarNav, SideBarType } from '@uplift/types';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import { Link } from 'react-router-dom';

import { NavigationItem as NavigationItemLink } from './navigation-item.component';
import { useStyles } from './side-bar.styles';
import { ROUTING_CONFIG } from '@uplift/constants';


const NavigationItem: React.FC<{ config: SideBarNav; toggleSideBar?: () => void }> = ({ config, toggleSideBar }) => {
  const { classes } = useStyles();

  if (config.type === 'link') {
    const item = config;

    return (
      <NavigationItemLink
        key={item.to}
        exact={item.exact ?? true}
        to={item.to}
        text={item.name}
        icon={item.icon}
        disabled={item.disabled}
        restricted={item.restricted}
        activeIcon={item.activeIcon}
        activeClassName={classes.activeNav}
        toggleSideBar={toggleSideBar}
        onDisabledClick={item.onDisabledClick}
      />
    );
  }

  if (config.type === 'button') {
    return (
      <ListItemButton className={classes.listItem} onClick={config.onClick} sx={{ color: 'rgba(0, 0, 0, 0.54)', }}>
        <ListItemIcon>
          <Badge badgeContent={config.badgeContent} color="error">
            {config.icon}
          </Badge>
        </ListItemIcon>
        <ListItemText primary="Messages" />
      </ListItemButton>
    );
  }

  return null;
};


export const SideBar: React.FC<SideBarType> = ({ mainNavConfig, infoNavConfig, toggleSideBar }) => {
  const l10n = useL10n();
  const { classes } = useStyles();

  return (
    <Box className={classes.sidebar}>
      <Box className={classes.wrapper}>
        <List className={classes.list}>
          {mainNavConfig?.map((item) => (
            <NavigationItem key={item.name} config={item} toggleSideBar={toggleSideBar} />
          ))}
        </List>

        {infoNavConfig && (
          <>
            <List className={classes.list}>
              <ListItem className={classes.listItem}>
                <div className={classes.tools}>{l10n.general.tools}</div>
              </ListItem>
            </List>

            <List className={classes.list}>
              {infoNavConfig.map((item) => {
                if (item.type !== 'link') {
                  return null;
                }

                if (item.to === '') {
                  return <span key={item.to} />;
                } else {
                  return (
                    <NavigationItemLink
                      key={item.to}
                      exact={item.exact ?? true}
                      to={item.to}
                      text={item.name}
                      icon={item.icon}
                      activeClassName={classes.activeNav}
                      toggleSideBar={toggleSideBar}
                    />
                  );
                }
              })}
            </List>
          </>
        )}
      </Box>
      <Box height="100%" />
      <Box className={classes.contactSupportContainer}>
        <Link
          className={classes.contactSupportLink}
          to={ROUTING_CONFIG.support}
        >
          <ContactSupportOutlinedIcon
            className={classes.contactSupportIcon}
          />
          <Typography className={classes.contactSupportText}>
            {l10n.pages.contactSupport}
          </Typography>
        </Link>
      </Box>

      <Box className={classes.privacy}>
        <a
          href="https://www.joinuplift.co/tos"
          rel="noreferrer"
          target="_blank"
        >
          {l10n.general.terms}
        </a>
        <p className={classes.dot}>•</p>
        <a
          href="https://www.joinuplift.co/privacy"
          rel="noreferrer"
          target="_blank"
        >
          {l10n.general.privacy}
        </a>
      </Box>
    </Box>
  );
};


// export const SideBar = ({
//   infoNavConfig,
//   mainNavConfig,
//   toggleSideBar,
// }: SideBarType) => {
//   return (
//     <ObservedSidebar
//       infoNavConfig={infoNavConfig}
//       mainNavConfig={mainNavConfig}
//       toggleSideBar={toggleSideBar}
//     />
//   );
// };
